module.exports = __webpack_public_path__ + "static/img/funny_04.b3c5a53f.jpg";